import type { CoordinationStatusEnum, CoordinationRequestStatusResume } from "../coordination";

export interface OperationRequestStatusResume {
    status: OperationStatusEnum;
    operationId: string;
    coordinationStatusMap: Map<CoordinationStatusEnum, number>;
    coRequestStatusList: CoordinationRequestStatusResume[];
}

export const OperationStatusColorCodeMap = {
  OPERATION_CREATING: '#0099bc', // primary accord
  OPERATION_REMOVED: '#eb445a', // danger
  OPERATION_PENDING_COORDINATION: '#f9c74f', // maizecrayola
  OPERATION_COORDINATED: '#43aa8b', // zomp
  OPERATION_ACTIVATED: '#90be6d', // pistachio
  OPERATION_DEACTIVATED: '#577590', // queenblue
  OPERATION_FINISHED: '#f9f4be', // dimmed
  OPERATION_SUSPENDED: '#f3722c', // orangered
  OPERATION_CANCELLED: '#f94144', // redsalsa
  OPERATION_UNDERTEST: '#5260ff', // tertiary
  OPERATION_EXPIRED: '#92949c', // medium
  OPERATION_REJECTED: '#f94144', // redsalsa
}

export enum OperationStatusColorEnum {
    OPERATION_UNKNOWN = 'medium',
    OPERATION_CREATING = 'primary',
    OPERATION_REMOVED = 'danger',
    OPERATION_PENDING_COORDINATION = 'maizecrayola',
    OPERATION_COORDINATED = 'zomp',
    OPERATION_ACTIVATED = 'pistachio',
    OPERATION_DEACTIVATED = 'queenblue',
    OPERATION_FINISHED = 'dimmed',
    OPERATION_SUSPENDED = 'orangered',
    OPERATION_CANCELLED = 'redsalsa',
    OPERATION_UNDERTEST = 'tertiary',
    OPERATION_EXPIRED = 'medium',
    OPERATION_REJECTED = 'redsalsa'
}

export enum OperationStatusEnum {
    OPERATION_UNKNOWN = 'OPERATION_UNKNOWN',
    OPERATION_CREATING = 'OPERATION_CREATING',
    OPERATION_REMOVED = 'OPERATION_REMOVED',
    OPERATION_PENDING_COORDINATION = 'OPERATION_PENDING_COORDINATION',
    OPERATION_COORDINATED = 'OPERATION_COORDINATED',
    OPERATION_ACTIVATED = 'OPERATION_ACTIVATED',
    OPERATION_DEACTIVATED = 'OPERATION_DEACTIVATED',
    OPERATION_FINISHED = 'OPERATION_FINISHED',
    OPERATION_SUSPENDED = 'OPERATION_SUSPENDED',
    OPERATION_CANCELLED = 'OPERATION_CANCELLED',
    OPERATION_UNDERTEST = 'OPERATION_UNDERTEST',
    OPERATION_EXPIRED = 'OPERATION_EXPIRED',
    OPERATION_REJECTED = 'OPERATION_REJECTED'
}

export enum OperationStatusTextEnum {
    OPERATION_UNKNOWN = 'Unknown',
    OPERATION_CREATING = 'Creating',
    OPERATION_REMOVED = 'Removed',
    OPERATION_PENDING_COORDINATION = 'Pending Coordination',
    OPERATION_COORDINATED = 'Coordinated',
    OPERATION_ACTIVATED = 'Activated',
    OPERATION_DEACTIVATED = 'Deactivated',
    OPERATION_FINISHED = 'Finished',
    OPERATION_SUSPENDED = 'Suspended',
    OPERATION_CANCELLED = 'Cancelled',
    OPERATION_UNDERTEST = 'Under Test',
    OPERATION_EXPIRED = 'Expired',
}